import {
  border,
  brandColors,
  breakpoints,
  colors,
  darkColors,
  primaryFont,
  primaryFontNew,
  radius,
  secondaryFont,
  secondaryFontNew,
  shadow,
  spacing,
} from '@thrivent/midwest-shared';
import { DefaultTheme } from 'styled-components';

declare module 'styled-components' {
  export interface DefaultTheme {
    font: {
      primary: string;
      secondary: string;
    };
    fontWeight: {
      primary: {
        heavy: string;
        semi: string;
        medium: string;
        reg: string;
        light: string;
      };
    };
    size: {
      [key: string]: number;
    };
    lineHeight: {
      [key: string]: number;
    };
    spacing: typeof spacing;
    shadow: typeof shadow;
    radius: typeof radius;
    breakpoints: typeof breakpoints;
    midwestColors: typeof brandColors;
    border: typeof border;
  }
}

export const theme: DefaultTheme = {
  font: {
    primary: primaryFont,
    secondary: secondaryFont,
  },
  fontWeight: {
    primary: {
      heavy: '700',
      semi: '600',
      medium: '500',
      reg: '400',
      light: '300',
    },
  },
  size: {
    mini: 10,
    '1': 12,
    '2': 14,
    '3': 16,
    '4': 18,
    '5': 20,
    '6': 22,
    '7': 24,
    '8': 28,
    '9': 32,
    '10': 36,
    '11': 40,
    '12': 48,
    '13': 54,
    '14': 60,
    '15': 68,
    '16': 76,
    '17': 84,
    '18': 96,
  },
  lineHeight: {
    xxxxs: 12,
    xxxs: 14,
    xxs: 16,
    xs: 18,
    s: 20,
    m: 22,
    l: 24,
    xl: 28,
    xxl: 32,
    xxxl: 36,
    xxxxl: 42,
    xxxxxl: 48,
    xxxxxxl: 52,
    xxxxxxxl: 72,
    mini: 14,
    default: 16,
  },
  spacing: spacing,
  shadow: shadow,
  radius: radius,
  breakpoints: breakpoints,
  midwestColors: colors,
  border: border,
};

export const inverseTheme: DefaultTheme = {
  font: {
    primary: primaryFontNew,
    secondary: secondaryFontNew,
  },
  fontWeight: {
    primary: {
      heavy: '800',
      semi: '700',
      medium: '500',
      reg: '400',
      light: '300',
    },
  },
  size: {
    mini: 12,
    '1': 14,
    '2': 16,
    '3': 18,
    '4': 20,
    '5': 22,
    '6': 24,
    '7': 28,
    '8': 32,
    '9': 36,
    '10': 40,
    '11': 44,
    '12': 48,
    '13': 54,
    '14': 60,
    '15': 68,
    '16': 76,
    '17': 84,
    '18': 96,
  },
  lineHeight: {
    xxxxs: 14,
    xxxs: 16,
    xxs: 18,
    xs: 20,
    s: 22,
    m: 24,
    l: 28,
    xl: 32,
    xxl: 40,
    xxxl: 44,
    xxxxl: 48,
    xxxxxl: 52,
    xxxxxxl: 56,
    xxxxxxxl: 72,
    mini: 14,
    default: 16,
  },
  spacing: spacing,
  shadow: shadow,
  radius: radius,
  breakpoints: breakpoints,
  midwestColors: darkColors,
  border: border,
};

export const thriventBrandTheme2025: DefaultTheme = {
  font: {
    primary: primaryFontNew,
    secondary: secondaryFontNew,
  },
  fontWeight: {
    primary: {
      heavy: '800',
      semi: '700',
      medium: '500',
      reg: '400',
      light: '300',
    },
  },
  size: {
    mini: 12,
    '1': 14,
    '2': 16,
    '3': 18,
    '4': 20,
    '5': 22,
    '6': 24,
    '7': 28,
    '8': 32,
    '9': 36,
    '10': 40,
    '11': 44,
    '12': 48,
    '13': 54,
    '14': 60,
    '15': 68,
    '16': 76,
    '17': 84,
    '18': 96,
  },
  lineHeight: {
    xxxxs: 14,
    xxxs: 16,
    xxs: 18,
    xs: 20,
    s: 22,
    m: 24,
    l: 28,
    xl: 32,
    xxl: 40,
    xxxl: 44,
    xxxxl: 48,
    xxxxxl: 52,
    xxxxxxl: 56,
    xxxxxxxl: 72,
    mini: 14,
    default: 16,
  },
  spacing: spacing,
  shadow: shadow,
  radius: radius,
  breakpoints: breakpoints,
  midwestColors: brandColors,
  border: border,
};

export type Theme = typeof theme;
export * from './globalStyles';
export * from './FontLoader';

export { StyledComponentsRegistry } from './Components/NextJS/StyledComponentsRegistry';
